// extracted by mini-css-extract-plugin
module.exports = {"families":"Navigation_families__wiopX","placeholder":"Navigation_placeholder__3vNIN","title":"Navigation_title__YNdMT"};